var radio = function (setting) {
	return {
		init: function () {
			var conditionalParent = setting.conditionalParent
			var required = null
			if (setting.settings) {
				required = setting.settings.mandatory.value
				if (required === '1') required = true
			}

			var listItem = document.createElement('li')
			var label = document.createElement('label')
			label.classList.add('flex-label')
			var span = document.createElement('span')
			span.innerHTML = setting.label

			var radioEl = document.createElement('input')
			radioEl.setAttribute('type', 'radio')
			radioEl.setAttribute('name', setting.name)
			radioEl.setAttribute('value', setting.value)
			if (required) radioEl.setAttribute('required', required)
			if (setting.checked) {
				radioEl.setAttribute('checked', '')
				radioEl.checked = true
			}

			if (setting.defaultValue === setting.value) {
				radioEl.setAttribute('checked', '')
				radioEl.checked = true
			}

			if (conditionalParent && conditionalParent === 'true') {
				radioEl.setAttribute('data-cond-value', setting.value)
			}

			if (setting.hidden) {
				listItem.classList.add('invisible-empty-radio')
				radioEl.classList.add('invisible-empty-radio')
			}

			label.appendChild(radioEl)
			label.appendChild(span)
			listItem.appendChild(label)

			return listItem
		}
	}
}

export default radio
